<h3 class="font-bold text-lg mb-4">
  {{ currentAccount?._id ? 'Update Bank Account' : 'Add Bank Account' }}
</h3>

@if (formError()) {
<div class="daisy-alert daisy-alert-error daisy-alert-sm mb-4">
  <i class="fa-solid fa-triangle-exclamation"></i>
  <span>{{ formError() }}</span>
</div>
}

<div class="space-y-4">
  <label class="daisy-form-control">
    <div class="daisy-label">
      <span class="daisy-label-text">Account Holder Name <span class="text-error">*</span></span>
    </div>
    <input
      type="text"
      class="daisy-input daisy-input-bordered"
      placeholder="Full name as per bank records"
      [ngModel]="accountHolderName()"
      (ngModelChange)="accountHolderName.set($event)"
    />
  </label>

  <label class="daisy-form-control">
    <div class="daisy-label">
      <span class="daisy-label-text">Bank Name <span class="text-error">*</span></span>
    </div>
    <input
      type="text"
      class="daisy-input daisy-input-bordered"
      placeholder="e.g. Bank of Ceylon"
      [ngModel]="bankName()"
      (ngModelChange)="bankName.set($event)"
    />
  </label>

  <label class="daisy-form-control">
    <div class="daisy-label">
      <span class="daisy-label-text">Branch Name <span class="text-error">*</span></span>
    </div>
    <input
      type="text"
      class="daisy-input daisy-input-bordered"
      placeholder="e.g. Colombo Main Branch"
      [ngModel]="branchName()"
      (ngModelChange)="branchName.set($event)"
    />
  </label>

  <label class="daisy-form-control">
    <div class="daisy-label">
      <span class="daisy-label-text">Account Number <span class="text-error">*</span></span>
    </div>
    <input
      type="text"
      class="daisy-input daisy-input-bordered"
      placeholder="Bank account number"
      [ngModel]="accountNumber()"
      (ngModelChange)="accountNumber.set($event)"
    />
  </label>

  <!-- Bank Book Upload (optional) -->
  <div class="daisy-form-control">
    <div class="daisy-label">
      <span class="daisy-label-text">
        <i class="fa-solid fa-book mr-1"></i>Bank Book Front Page
        <span class="text-base-content/40 text-xs ml-1">(optional)</span>
      </span>
    </div>
    <file-pond
      #bankBookPond
      [options]="pondOptions"
      [files]="pondFiles"
      (onprocessfile)="pondHandleProcessFile($event)"
      (onremovefile)="pondHandleRemoveFile()"
    ></file-pond>
    <div class="daisy-label">
      <span class="daisy-label-text-alt text-base-content/40">
        Accepted: JPEG, PNG or PDF
      </span>
    </div>
  </div>
</div>

<div class="daisy-modal-action">
  <button class="daisy-btn daisy-btn-ghost" (click)="cancel()">Cancel</button>
  <button class="daisy-btn daisy-btn-primary" (click)="submit()">
    Save Account
  </button>
</div>
